import { combineReducers } from 'redux';

import shortCode from './shortCode';
import shortCodeStatus from './shortCodeStatus';
import adobe from './adobe';
import paramountPlus from './paramountPlus';

export default combineReducers({
  shortCode,
  shortCodeStatus,
  adobe,
  paramountPlus,
});
